import * as React from 'react';

import { PoweredByCirium } from './PoweredByCirium';
import { BrandingImage } from '../cirium/BrandingImage';

import { Box, Flex, Heading2, thc } from '@flightstats/airframe-react';
import styles from './poweredByCirium.module.css';

const PageContainer = thc(Flex, {
  flexDirection: 'column',
  height: '100%',
  margin: '0 auto',
  maxWidth: '1024px',
});

const ResponsivePoweredByCirium = thc(PoweredByCirium, {
  textAlign: { xs: 'center', md: 'left' },
});

type Props = {
  brandingImageUrl?: string | null,
  title: string,
  children?: React.ReactNode,
};

export const CiriumPage: React.FC<Props> = ({ brandingImageUrl, title, children }) => (
  <PageContainer>
    {brandingImageUrl && (
      <Flex className={styles.flexContainer}>
        {brandingImageUrl && <BrandingImage mb="10px" url={brandingImageUrl} />}
      </Flex>
    )}
    <Heading2 spacing={2}>{title}</Heading2>
    <Box className={styles.pageContainer}>{children}</Box>
    <ResponsivePoweredByCirium />
  </PageContainer>
);